import React, { useEffect, useState } from 'react'
import { useRedirect, useRefresh, useTranslate, useUserMenu } from 'react-admin';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import PersonIcon from '@mui/icons-material/Person';
import DoneIcon from '@mui/icons-material/Done';
import { Tooltip } from '@mui/material';
import { userServices } from 'src/services/auth/user/user.service';
import { ConfirmationDialog } from 'src/components/uiElements/styledComponents/ConfirmationDialog';

export const ManageClients = ({confirmChangeClient, setConfirmChangeClient}) => {
    const translate = useTranslate()
    const clients = JSON.parse(localStorage.getItem('clients')) ?? []
    const user = JSON.parse(localStorage.getItem('user'))
    const [selectedClient, setSelecteClient] = useState(user?.client_id ?? null)
    const [openConfirmation, setOpenConfirmation] = useState(false)
    const [loadingChangeClient, setLoadingChangeClient] = useState(false)
    const [newClient, setNewClient] = useState(null)
    const refresh = useRefresh();
    const redirect = useRedirect()
    const { onClose } = useUserMenu()

    useEffect(()=>{
      if(confirmChangeClient)
        changeClient(newClient)
    },[confirmChangeClient])

    const changeClient = async (new_client) =>{
      const new_selection = clients.find(client=>client.client_id === new_client)
      if(new_selection){
        redirect('./')
        setLoadingChangeClient(true)
        await userServices.loginByToken(new_selection.jwt).then((tokenResponse)=>{
            tokenResponse.application.modules.forEach((module) => {
            const permissions = []
            module.permission.forEach((permission) => {
              if (!permissions.find((elem) => elem.entity_id === permission.entity_id)) {
                permissions.push(permission)
              }
            })
            module.permission = permissions
          })
          localStorage.setItem('jwt', new_selection.jwt)
          localStorage.setItem('application', JSON.stringify(tokenResponse.application))
          localStorage.setItem(
            'user',
            JSON.stringify({
              ...user,
              roles: tokenResponse.roles,
              dashboard: tokenResponse?.dashboard,
              client_id: tokenResponse?.client_id,
              client_hash: new_selection?.hash_client,
            })
          )
          setSelecteClient(new_selection.client_id)
          setOpenConfirmation(false)
          setConfirmChangeClient(false)
          refresh()
          onClose()
        }).finally(()=>{
          setLoadingChangeClient(false)
        })
        
      }
    }

    return (
    <>
      <label style={{margin:'5px 0px 5px 15px',color:'#6f7ce0', fontWeight:'bold', fontSize:'12px', display:'flex', flexDirection:'row', alignItems:'center'}}>
        {translate('ra.title.clients')}
        <Tooltip title={translate('ra.message.client_tooltip')} className='tooltip' placement='bottom'>
          <InfoOutlinedIcon style={{fontSize:'17px', textAlign:'center', marginLeft:'5px', cursor:'pointer'}}/>
        </Tooltip>
      </label>
      <div style={{display:'flex', flexDirection:'column'}}>
        {
          clients.map(client=>(
            <div 
            key={client.client_id}
            onClick={()=>{
              if(selectedClient !== client.client_id){
                setOpenConfirmation(true);
                setNewClient(client.client_id)
              }  }}
              style={{
                display:'flex', 
                flexDirection:'row', 
                justifyContent:'space-between', 
                alignItems:'center',
                paddingLeft:'15px',
                backgroundColor:selectedClient === client.client_id && '#d1d4f4ff',
                cursor:selectedClient !== client.client_id && 'pointer'
              }}>
              <label style={{
                  display:'flex', 
                  flexDirection:'row', 
                  alignItems:'center', 
                  color:selectedClient === client.client_id ? '#6f7ce0': '#5a5b5cff', 
                  marginTop:'5px',
                  marginBottom:'5px',
                  cursor:'inherit'
              }}>
                <PersonIcon style={{fontSize:'17px', marginRight:'5px'}}/>
                {client.name}
              </label>
              {selectedClient === client.client_id  && <DoneIcon color='info' style={{marginRight:'15px'}}/>}
            </div>
          ))
        }
      </div>
      <ConfirmationDialog
          title={translate('ra.message.client_change_confirmation')}
          buttonConfirmText={translate('ra.action.to_confirm')}
          buttonCancel={translate('ra.action.cancel')}
          setOpen={setOpenConfirmation}
          loadingModalButton={loadingChangeClient}
          setConfirm={setConfirmChangeClient}
          open={openConfirmation}
        />
    </>
  )
}
